import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc,
  setDoc,
  query,
  orderBy,
  serverTimestamp
} from "firebase/firestore";

import { db } from "../firebase/firebase";
import { Link, useNavigate } from "react-router-dom";

export default function BlogJSON() {
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [newBlogJson, setNewBlogJson] = useState("");
  const [jsonEditingIndex, setJsonEditingIndex] =
    useState(null);
  const [jsonEditingValue, setJsonEditingValue] =
    useState("");

  useEffect(() => {
    loadBlogs();
  }, []);

  const generateSlug = (title) =>
    title
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "");

  const readingTime = (text) =>
    Math.ceil(text.split(/\s+/).length / 200);

  const loadBlogs = async () => {
    const q = query(
      collection(db, "blogs"),
      orderBy("createdAt", "desc")
    );

    const snap = await getDocs(q);

    setBlogs(
      snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }))
    );
  };

  const handleAddBlog = async () => {
    try {
      const parsed =
        JSON.parse(newBlogJson);

      await addDoc(
        collection(db, "blogs"),
        {
          ...parsed,
          slug: generateSlug(
            parsed.title
          ),
          readingTime:
            readingTime(
              parsed.content
            ),
          createdAt:
            serverTimestamp(),
          updatedAt:
            serverTimestamp(),
          views: 0,
          likes: 0
        }
      );

      setNewBlogJson("");
      loadBlogs();

      alert("Blog Added ✅");
    } catch {
      alert("Invalid JSON ❌");
    }
  };

  const handleDelete = async (id) => {
    if (
      !window.confirm(
        "Delete blog?"
      )
    )
      return;

    await deleteDoc(
      doc(db, "blogs", id)
    );

    loadBlogs();
  };

  const handleJsonEdit = (
    index,
    blog
  ) => {
    setJsonEditingIndex(index);

    setJsonEditingValue(
      JSON.stringify(
        blog,
        null,
        2
      )
    );
  };

  const handleJsonUpdate = async (
    blogId
  ) => {
    try {
      const parsed =
        JSON.parse(
          jsonEditingValue
        );

      await setDoc(
        doc(db, "blogs", blogId),
        {
          ...parsed,
          updatedAt:
            serverTimestamp()
        }
      );

      setJsonEditingIndex(null);
      setJsonEditingValue("");

      loadBlogs();

      alert(
        "Updated ✅"
      );
    } catch {
      alert(
        "Invalid JSON ❌"
      );
    }
  };

  return (
    <div className="text-white p-8">
      <div className="flex justify-between mb-8">
        <h1 className="text-3xl font-bold text-orange-500">
          Blog JSON
        </h1>

        <button
          onClick={() =>
            navigate(
              "/dashboard/blogs"
            )
          }
          className="bg-white/10 px-4 py-2 rounded-lg"
        >
          Back
        </button>
      </div>

      <div className="bg-white/5 p-6 rounded-2xl mb-8">
        <textarea
          rows={16}
          value={newBlogJson}
          onChange={(e) =>
            setNewBlogJson(
              e.target.value
            )
          }
          placeholder="Paste blog JSON"
          className="w-full p-4 rounded-xl bg-black/30 font-mono"
        />

        <button
          onClick={
            handleAddBlog
          }
          className="mt-4 bg-orange-500 px-6 py-3 rounded-xl"
        >
          Add Blog
        </button>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {blogs.map(
          (
            blog,
            index
          ) => (
            <div
              key={
                blog.id
              }
              className="bg-white/5 p-5 rounded-2xl"
            >
              {jsonEditingIndex ===
                index ? (
                <>
                  <textarea
                    rows={
                      20
                    }
                    value={
                      jsonEditingValue
                    }
                    onChange={(
                      e
                    ) =>
                      setJsonEditingValue(
                        e
                          .target
                          .value
                      )
                    }
                    className="w-full p-4 bg-black/30 rounded-xl font-mono"
                  />

                  <div className="flex gap-2 mt-3">
                    <button
                      onClick={() =>
                        handleJsonUpdate(
                          blog.id
                        )
                      }
                      className="flex-1 bg-green-600 py-2 rounded"
                    >
                      Save
                    </button>

                    <button
                      onClick={() =>
                        setJsonEditingIndex(
                          null
                        )
                      }
                      className="flex-1 bg-gray-600 py-2 rounded"
                    >
                      Cancel
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex">
                    <div className="w-[25%]">
                      <img src={blog.image} className="w-full" />
                    </div>
                    <h3 className="font-semibold p-2">
                      {
                        blog.title
                      }
                    </h3>
                  </div>

                  <div className="flex gap-2 mt-4">
                    <Link
                      to={"/dashboard/blog-view?id=" + blog.id}
                      className="flex-1 bg-purple-600 py-2 rounded text-center"
                    >
                      View
                    </Link>
                    <button
                      onClick={() =>
                        handleJsonEdit(
                          index,
                          blog
                        )
                      }
                      className="flex-1 bg-purple-600 py-2 rounded"
                    >
                      JSON
                    </button>

                    <button
                      onClick={() =>
                        handleDelete(
                          blog.id
                        )
                      }
                      className="flex-1 bg-red-600 py-2 rounded"
                    >
                      Delete
                    </button>
                  </div>
                </>
              )}
            </div>
          )
        )}
      </div>
    </div>
  );
}